export const VIEW_PATHS_ACCESS_SOLUTIONS_PLATFORM = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  SELECT_PLAN: '/select-plan',
  SPONSOR_SELECT: '/partner-welcome',
  AGENT_SELECT_PLAN: '/agent-select-plan',
  AGENT_REGISTER: '/agent-register',
  AGENT_CHECKOUT: '/agent-checkout',
  AGENT_CONFIRM_EMAIL: '/agent-confirm-email',
  CONFIRM_LISTING_DASHBOARD_EMAIL: '/confirm-listing-dashboard-email',
  AGENT_VERIFY: '/agent-verify',
  CHECKOUT: '/checkout',
  CONFIRM_EMAIL_CHANGE: '/change-email',
  PAYMENT_SUPPORT: '/payment-support',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ACCEPT_INVITATION: '/accept-invitation',
  LEGACY_REGISTRATION: '/registration/email',
  LEGACY_SIGN_UP: '/sign-up',
  LEGACY_JOIN_ORG: '/join-org',
  LEGACY_INVITE: '/invite',
  CONFIRM_USER: '/confirm-user',
  SSO_LOGIN: '/sso/:orgSlug',
  PRODUCT_SHEET: '/product-details/:applicationKey',
  MLS_COVERAGE: '/mls-coverage',
  LINK_SPONSOR_ACCOUNT_SENT: '/link-sponsor-account-sent',
  LINK_SPONSOR_ACCOUNT_CONFIRM: '/link-sponsor-account',
  BROKER_AUTHORIZATION: '/broker-authorization/:scope',
  BROKER_AUTHORIZATION_DECLINE: '/broker-authorization/decline',
  MY_STATE_SIGNUP: '/sign-up/mystate',
} as const;
